export default "__VITE_ASSET__fb7e57ba__"